import { createContext } from "react";
import type { PlanTier, PaywallError } from "../services/billingApi";
import type { GatedFeature } from "../data/planRules";

/** What the user was trying to do when they hit the wall. */
export type PaywallRequest = {
  title: string;
  description: string;
  /** Highlight the Basic Pass design restriction as a warning. */
  notice?: "basic-design";
  /** Plans to offer, cheapest first. Defaults to the full paid ladder. */
  suggestedTiers?: PlanTier[];
  /** Feature that triggered it, when applicable. */
  feature?: GatedFeature;
  /** Path to return to after payment, e.g. "/editor?cv=123". */
  returnPath?: string;
  /** Design selected when the download was refused. */
  templateKey?: string;
  /** Switch the current CV to the Legacy design without starting an export. */
  onUseLegacy?: () => void;
};

export type PaywallContextValue = {
  /** Open the upgrade modal with explicit copy. */
  openPaywall: (request: PaywallRequest) => void;
  /** Open it straight from a server 403 body. */
  openPaywallFromError: (
    error: PaywallError,
    returnPath?: string,
    onUseLegacy?: () => void,
    templateKey?: string,
  ) => void;
  /** Open the modal for a locked capability, using its standard copy. */
  openFeaturePaywall: (feature: GatedFeature, returnPath?: string) => void;
  closePaywall: () => void;
  isOpen: boolean;
};

export const PaywallContext = createContext<PaywallContextValue | undefined>(
  undefined,
);
